export const SHEET_ID = '1oVS2YhdHqpG2bmrpuOoM3e0C6DyIB3XvEJKtEOsenGc';
export const VEHICLES_API_URL = 'https://api.itspsd.in/la-vehicles/';

export const bankLocations = [
  { value: 'fleeca_legion_square', label: 'Fleeca Bank (Legion Square)' },
  { value: 'fleeca_del_perro', label: 'Fleeca Bank (Del Perro)' },
  { value: 'fleeca_hawick', label: 'Fleeca Bank (Hawick)' },
  { value: 'fleeca_banham_canyon', label: 'Fleeca Bank (Banham Canyon)' },
  { value: 'fleeca_harmony', label: 'Fleeca Bank (Harmony)' },
  { value: 'fleeca_paleto_bay', label: 'Fleeca Bank (Paleto Bay)' },  
  { value: 'pacific_standard', label: 'Pacific Standard' },
  { value: 'fleeca_pinkcage', label: 'Fleeca Bank (Pinkcage)' },
];

export const stockadeLocations = [
  // Los Santos 
  { value: 'abattoir_avenue', label: 'Abattoir Avenue' },
  { value: 'abe_milton_parkway', label: 'Abe Milton Parkway' },
  { value: 'ace_jones_drive', label: 'Ace Jones Drive' },
  { value: 'adams_apple_boulevard', label: "Adam's Apple Boulevard" },
  { value: 'aguja_street', label: 'Aguja Street' },
  { value: 'alta_place', label: 'Alta Place' },
  { value: 'alta_street', label: 'Alta Street' },
  { value: 'amarillo_vista', label: 'Amarillo Vista' },
  { value: 'amarillo_way', label: 'Amarillo Way' },
  { value: 'americano_way', label: 'Americano Way' },
  { value: 'atlee_street', label: 'Atlee Street' },
  { value: 'autopia_parkway', label: 'Autopia Parkway' },
  { value: 'banham_canyon_drive', label: 'Banham Canyon Drive' },
  { value: 'barbareno_road', label: 'Barbareno Road' },
  { value: 'bay_city_avenue', label: 'Bay City Avenue' },
  { value: 'bay_city_incline', label: 'Bay City Incline' },
  { value: 'baytree_canyon_road', label: 'Baytree Canyon Road' },
  { value: 'boulevard_del_perro', label: 'Boulevard Del Perro' },
  { value: 'bridge_street', label: 'Bridge Street' },
  { value: 'brouge_avenue', label: 'Brouge Avenue' },
  { value: 'buccaneer_way', label: 'Buccaneer Way' },
  { value: 'buen_vino_road', label: 'Buen Vino Road' },
  { value: 'caesars_place', label: 'Caesars Place' },
  { value: 'calais_avenue', label: 'Calais Avenue' },
  { value: 'capital_boulevard', label: 'Capital Boulevard' },
  { value: 'carcer_way', label: 'Carcer Way' },
  { value: 'carson_avenue', label: 'Carson Avenue' },
  { value: 'chum_street', label: 'Chum Street' },
  { value: 'chupacabra_street', label: 'Chupacabra Street' },
  { value: 'clinton_avenue', label: 'Clinton Avenue' },
  { value: 'cockingend_drive', label: 'Cockingend Drive' },
  { value: 'conquistador_street', label: 'Conquistador Street' },
  { value: 'cortes_street', label: 'Cortes Street' },
  { value: 'cougar_avenue', label: 'Cougar Avenue' },
  { value: 'covenant_avenue', label: 'Covenant Avenue' },
  { value: 'cox_way', label: 'Cox Way' },
  { value: 'crusade_road', label: 'Crusade Road' },
  { value: 'davis_avenue', label: 'Davis Avenue' },
  { value: 'decker_street', label: 'Decker Street' },
  { value: 'didion_drive', label: 'Didion Drive' },
  { value: 'dorset_drive', label: 'Dorset Drive' },
  { value: 'dorset_place', label: 'Dorset Place' },
  { value: 'dry_dock_street', label: 'Dry Dock Street' },
  { value: 'dunstable_drive', label: 'Dunstable Drive' },
  { value: 'dunstable_lane', label: 'Dunstable Lane' },
  { value: 'dutch_london_street', label: 'Dutch London Street' },
  { value: 'eastbourne_way', label: 'Eastbourne Way' },
  { value: 'east_galileo_avenue', label: 'East Galileo Avenue' },
  { value: 'east_mirror_drive', label: 'East Mirror Drive' },
  { value: 'eclipse_boulevard', label: 'Eclipse Boulevard' },
  { value: 'edwood_way', label: 'Edwood Way' },
  { value: 'elgin_avenue', label: 'Elgin Avenue' },
  { value: 'el_burro_boulevard', label: 'El Burro Boulevard' },
  { value: 'el_rancho_boulevard', label: 'El Rancho Boulevard' },
  { value: 'equality_way', label: 'Equality Way' },
  { value: 'exceptionalists_way', label: 'Exceptionalists Way' },
  { value: 'fantastic_place', label: 'Fantastic Place' },
  { value: 'fenwell_place', label: 'Fenwell Place' },
  { value: 'forum_drive', label: 'Forum Drive' },
  { value: 'fudge_lane', label: 'Fudge Lane' },
  { value: 'galileo_road', label: 'Galileo Road' },
  { value: 'gentry_lane', label: 'Gentry Lane' },
  { value: 'ginger_street', label: 'Ginger Street' },
  { value: 'glory_way', label: 'Glory Way' },
  { value: 'goma_street', label: 'Goma Street' },
  { value: 'greenwich_parkway', label: 'Greenwich Parkway' },
  { value: 'greenwich_place', label: 'Greenwich Place' },
  { value: 'greenwich_way', label: 'Greenwich Way' },
  { value: 'grove_street', label: 'Grove Street' },
  { value: 'hanger_way', label: 'Hanger Way' },
  { value: 'hangman_avenue', label: 'Hangman Avenue' },
  { value: 'hardy_way', label: 'Hardy Way' },
  { value: 'hawick_avenue', label: 'Hawick Avenue' },
  { value: 'heritage_way', label: 'Heritage Way' },
  { value: 'hillcrest_avenue', label: 'Hillcrest Avenue' },
  { value: 'hillcrest_ridge_access_road', label: 'Hillcrest Ridge Access Road' },
  { value: 'imagination_court', label: 'Imagination Court' },
  { value: 'industry_passage', label: 'Industry Passage' },
  { value: 'ineseno_road', label: 'Ineseno Road' },
  { value: 'integrity_way', label: 'Integrity Way' },
  { value: 'invention_court', label: 'Invention Court' },
  { value: 'innocence_boulevard', label: 'Innocence Boulevard' },
  { value: 'jamestown_street', label: 'Jamestown Street' },
  { value: 'kimble_hill_drive', label: 'Kimble Hill Drive' },
  { value: 'kortz_drive', label: 'Kortz Drive' },
  { value: 'labor_place', label: 'Labor Place' },
  { value: 'laguna_place', label: 'Laguna Place' },
  { value: 'lake_vinewood_drive', label: 'Lake Vinewood Drive' },
  { value: 'las_lagunas_boulevard', label: 'Las Lagunas Boulevard' },
  { value: 'liberty_street', label: 'Liberty Street' },
  { value: 'lindsay_circus', label: 'Lindsay Circus' },
  { value: 'little_bighorn_avenue', label: 'Little Bighorn Avenue' },
  { value: 'low_power_street', label: 'Low Power Street' },
  { value: 'macdonald_street', label: 'Macdonald Street' },
  { value: 'mad_wayne_thunder_drive', label: 'Mad Wayne Thunder Drive' },
  { value: 'magellan_avenue', label: 'Magellan Avenue' },
  { value: 'marathon_avenue', label: 'Marathon Avenue' },
  { value: 'marlowe_drive', label: 'Marlowe Drive' },
  { value: 'melanoma_street', label: 'Melanoma Street' },
  { value: 'meteor_street', label: 'Meteor Street' },
  { value: 'milton_road', label: 'Milton Road' },
  { value: 'mirror_park_boulevard', label: 'Mirror Park Boulevard' },
  { value: 'mirror_place', label: 'Mirror Place' },
  { value: 'morningwood_boulevard', label: 'Morningwood Boulevard' },
  { value: 'mount_haan_drive', label: 'Mount Haan Drive' },
  { value: 'mount_haan_road', label: 'Mount Haan Road' },
  { value: 'mount_vinewood_drive', label: 'Mount Vinewood Drive' },
  { value: 'movie_star_way', label: 'Movie Star Way' },
  { value: 'mutiny_road', label: 'Mutiny Road' },
  { value: 'new_empire_way', label: 'New Empire Way' },
  { value: 'nikola_avenue', label: 'Nikola Avenue' },
  { value: 'nikola_place', label: 'Nikola Place' },
  { value: 'normandy_drive', label: 'Normandy Drive' },
  { value: 'north_archer_avenue', label: 'North Archer Avenue' },
  { value: 'north_conker_avenue', label: 'North Conker Avenue' },
  { value: 'north_sheldon_avenue', label: 'North Sheldon Avenue' },
  { value: 'north_rockford_drive', label: 'North Rockford Drive' },
  { value: 'occupation_avenue', label: 'Occupation Avenue' },
  { value: 'orchardville_avenue', label: 'Orchardville Avenue' },
  { value: 'palomino_avenue', label: 'Palomino Avenue' },
  { value: 'peaceful_street', label: 'Peaceful Street' },
  { value: 'perth_street', label: 'Perth Street' },
  { value: 'picture_perfect_drive', label: 'Picture Perfect Drive' },
  { value: 'plaice_place', label: 'Plaice Place' },
  { value: 'playa_vista', label: 'Playa Vista' },
  { value: 'popular_street', label: 'Popular Street' },
  { value: 'portola_drive', label: 'Portola Drive' },
  { value: 'power_street', label: 'Power Street' },
  { value: 'prosperity_street', label: 'Prosperity Street' },
  { value: 'prosperity_street_promenade', label: 'Prosperity Street Promenade' },
  { value: 'red_desert_avenue', label: 'Red Desert Avenue' },
  { value: 'richman_street', label: 'Richman Street' },
  { value: 'rockford_drive', label: 'Rockford Drive' },
  { value: 'roy_lowenstein_boulevard', label: 'Roy Lowenstein Boulevard' },
  { value: 'rub_street', label: 'Rub Street' },
  { value: 'sam_austin_drive', label: 'Sam Austin Drive' },
  { value: 'san_andreas_avenue', label: 'San Andreas Avenue' },
  { value: 'sandcastle_way', label: 'Sandcastle Way' },
  { value: 'san_vitus_boulevard', label: 'San Vitus Boulevard' },
  { value: 'senora_road', label: 'Senora Road' },
  { value: 'shank_street', label: 'Shank Street' },
  { value: 'signal_street', label: 'Signal Street' },
  { value: 'sinner_street', label: 'Sinner Street' },
  { value: 'sinners_passage', label: 'Sinners Passage' },
  { value: 'south_arsenal_street', label: 'South Arsenal Street' },
  { value: 'south_boulevard_del_perro', label: 'South Boulevard Del Perro' },
  { value: 'south_mo_milton_drive', label: 'South Mo Milton Drive' },
  { value: 'south_rockford_drive', label: 'South Rockford Drive' },
  { value: 'south_shambles_street', label: 'South Shambles Street' },
  { value: 'spanish_avenue', label: 'Spanish Avenue' },
  { value: 'steele_way', label: 'Steele Way' },
  { value: 'strangeways_drive', label: 'Strangeways Drive' },
  { value: 'strawberry_avenue', label: 'Strawberry Avenue' },
  { value: 'supply_street', label: 'Supply Street' },
  { value: 'sustancia_road', label: 'Sustancia Road' },
  { value: 'swiss_street', label: 'Swiss Street' },
  { value: 'tackle_street', label: 'Tackle Street' },
  { value: 'tangerine_street', label: 'Tangerine Street' },
  { value: 'tongva_drive', label: 'Tongva Drive' },
  { value: 'tower_way', label: 'Tower Way' },
  { value: 'tug_street', label: 'Tug Street' },
  { value: 'utopia_gardens', label: 'Utopia Gardens' },
  { value: 'vespucci_boulevard', label: 'Vespucci Boulevard' },
  { value: 'vinewood_boulevard', label: 'Vinewood Boulevard' },
  { value: 'vinewood_park_drive', label: 'Vinewood Park Drive' },
  { value: 'vitus_street', label: 'Vitus Street' },
  { value: 'voodoo_place', label: 'Voodoo Place' },
  { value: 'west_eclipse_boulevard', label: 'West Eclipse Boulevard' },
  { value: 'west_galileo_avenue', label: 'West Galileo Avenue' },
  { value: 'west_mirror_drive', label: 'West Mirror Drive' },
  { value: 'whispymound_drive', label: 'Whispymound Drive' },
  { value: 'wild_oats_drive', label: 'Wild Oats Drive' },
  { value: 'york_street', label: 'York Street' },
  { value: 'zancudo_barranca', label: 'Zancudo Barranca' },
  // Blaine County
  { value: 'algonquin_boulevard', label: 'Algonquin Boulevard' },
  { value: 'alhambra_drive', label: 'Alhambra Drive' },
  { value: 'armadillo_avenue', label: 'Armadillo Avenue' },
  { value: 'baytree_canyon_road', label: 'Baytree Canyon Road' },
  { value: 'calafia_road', label: 'Calafia Road' },
  { value: 'cascabel_avenue', label: 'Cascabel Avenue' },
  { value: 'cassidy_trail', label: 'Cassidy Trail' },
  { value: 'cat_claw_avenue', label: 'Cat-Claw Avenue' },
  { value: 'chianski_passage', label: 'Chianski Passage' },
  { value: 'cholla_road', label: 'Cholla Road' },
  { value: 'cholla_springs_avenue', label: 'Cholla Springs Avenue' },
  { value: 'duluoz_avenue', label: 'Duluoz Avenue' },
  { value: 'east_joshua_road', label: 'East Joshua Road' },
  { value: 'fort_zancudo_approach_road', label: 'Fort Zancudo Approach Road' },
  { value: 'galileo_road', label: 'Galileo Road' },
  { value: 'grapeseed_avenue', label: 'Grapeseed Avenue' },
  { value: 'grapeseed_main_street', label: 'Grapeseed Main Street' },
  { value: 'joad_lane', label: 'Joad Lane' },
  { value: 'joshua_road', label: 'Joshua Road' },
  { value: 'lesbos_lane', label: 'Lesbos Lane' },
  { value: 'lolita_avenue', label: 'Lolita Avenue' },
  { value: 'marina_drive', label: 'Marina Drive' },
  { value: 'meringue_lane', label: 'Meringue Lane' },
  { value: 'mount_haan_road', label: 'Mount Haan Road' },
  { value: 'mountain_view_drive', label: 'Mountain View Drive' },
  { value: 'niland_avenue', label: 'Niland Avenue' },
  { value: 'north_calafia_way', label: 'North Calafia Way' },
  { value: 'nowhere_road', label: 'Nowhere Road' },
  { value: 'oneil_way', label: "O'Neil Way" },
  { value: 'paleto_boulevard', label: 'Paleto Boulevard' },
  { value: 'panorama_drive', label: 'Panorama Drive' },
  { value: 'procopio_drive', label: 'Procopio Drive' },
  { value: 'procopio_promenade', label: 'Procopio Promenade' },
  { value: 'pyrite_avenue', label: 'Pyrite Avenue' },
  { value: 'raton_pass', label: 'Raton Pass' },
  { value: 'route_68_approach', label: 'Route 68 Approach' },
  { value: 'seaview_road', label: 'Seaview Road' },
  { value: 'senora_way', label: 'Senora Way' },
  { value: 'smoke_tree_road', label: 'Smoke Tree Road' },
  { value: 'union_road', label: 'Union Road' },
  { value: 'zancudo_avenue', label: 'Zancudo Avenue' },
  { value: 'zancudo_road', label: 'Zancudo Road' },
  { value: 'zancudo_trail', label: 'Zancudo Trail' },
  // San Andreas Highways
  { value: 'great_ocean_highway', label: 'Great Ocean Highway' },
  { value: 'tongva_drive', label: 'Tongva Drive' },
  { value: 'senora_freeway', label: 'Senora Freeway' },
  { value: 'palomino_freeway', label: 'Palomino Freeway' },
  { value: 'elysian_fields_freeway', label: 'Elysian Fields Freeway' },
  { value: 'route_68', label: 'Route 68' },
  { value: 'del_perro_freeway', label: 'Del Perro Freeway' },
  { value: 'los_santos_freeway', label: 'Los Santos Freeway' },
  { value: 'olympic_freeway', label: 'Olympic Freeway' },
  { value: 'la_puerta_freeway', label: 'La Puerta Freeway' },
];

export const storeLocations = [
  { value: '247_strawberry', label: '24/7 (Strawberry)' },
  { value: '247_downtown_vinewood', label: '24/7 (Downtown Vinewood)' },
  { value: '247_tataviam_mountains', label: '24/7 (Tataviam Mountains)' },
  { value: '247_banham_canyon', label: '24/7 (Banham Canyon)' },
  { value: '247_chumash', label: '24/7 (Chumash)' },
  { value: '247_harmony', label: '24/7 (Harmony)' },
  { value: '247_grand_senora', label: '24/7 (Grand Senora)' },
  { value: '247_sandy_shores', label: '24/7 (Sandy Shores)' },
  { value: '247_mount_chiliad', label: '24/7 (Mount Chiliad)' },
  { value: 'ltd_davis', label: 'LTD (Davis)' },
  { value: 'ltd_little_seoul', label: 'LTD (Little Seoul)' },
  { value: 'ltd_mirror_park', label: 'LTD (Mirror Park)' },
  { value: 'ltd_richman_glen', label: 'LTD (Richman Glen)' },
  { value: 'ltd_grapeseed', label: 'LTD (Grapeseed)' },  
  { value: 'rob_liquor_murrieta', label: "Rob's Liquor (Murrieta Heights)" },
  { value: 'rob_liquor_vespucci', label: "Rob's Liquor (Vespucci Canals)" },
  { value: 'rob_liquor_morningwood', label: "Rob's Liquor (Morningwood)" },
  { value: 'rob_liquor_banham', label: "Rob's Liquor (Banham Canyon)" },
  { value: 'rob_liquor_grand_senora', label: "Rob's Liquor (Grand Senora)" },
  { value: 'liquor_ace_sandy_shores', label: "Liquor Ace (Sandy Shores)" },  
];

export const drugLocations = [
  // Los Santos 
  { value: 'abattoir_avenue', label: 'Abattoir Avenue' },
  { value: 'abe_milton_parkway', label: 'Abe Milton Parkway' },
  { value: 'ace_jones_drive', label: 'Ace Jones Drive' },
  { value: 'adams_apple_boulevard', label: "Adam's Apple Boulevard" },
  { value: 'aguja_street', label: 'Aguja Street' },
  { value: 'alta_place', label: 'Alta Place' },
  { value: 'alta_street', label: 'Alta Street' },
  { value: 'amarillo_vista', label: 'Amarillo Vista' },
  { value: 'amarillo_way', label: 'Amarillo Way' },
  { value: 'americano_way', label: 'Americano Way' },
  { value: 'atlee_street', label: 'Atlee Street' },
  { value: 'autopia_parkway', label: 'Autopia Parkway' },
  { value: 'banham_canyon_drive', label: 'Banham Canyon Drive' },
  { value: 'barbareno_road', label: 'Barbareno Road' },
  { value: 'bay_city_avenue', label: 'Bay City Avenue' },
  { value: 'bay_city_incline', label: 'Bay City Incline' },
  { value: 'baytree_canyon_road', label: 'Baytree Canyon Road' },
  { value: 'boulevard_del_perro', label: 'Boulevard Del Perro' },
  { value: 'bridge_street', label: 'Bridge Street' },
  { value: 'brouge_avenue', label: 'Brouge Avenue' },
  { value: 'buccaneer_way', label: 'Buccaneer Way' },
  { value: 'buen_vino_road', label: 'Buen Vino Road' },
  { value: 'caesars_place', label: 'Caesars Place' },
  { value: 'calais_avenue', label: 'Calais Avenue' },
  { value: 'capital_boulevard', label: 'Capital Boulevard' },
  { value: 'carcer_way', label: 'Carcer Way' },
  { value: 'carson_avenue', label: 'Carson Avenue' },
  { value: 'chum_street', label: 'Chum Street' },
  { value: 'chupacabra_street', label: 'Chupacabra Street' },
  { value: 'clinton_avenue', label: 'Clinton Avenue' },
  { value: 'cockingend_drive', label: 'Cockingend Drive' },
  { value: 'conquistador_street', label: 'Conquistador Street' },
  { value: 'cortes_street', label: 'Cortes Street' },
  { value: 'cougar_avenue', label: 'Cougar Avenue' },
  { value: 'covenant_avenue', label: 'Covenant Avenue' },
  { value: 'cox_way', label: 'Cox Way' },
  { value: 'crusade_road', label: 'Crusade Road' },
  { value: 'davis_avenue', label: 'Davis Avenue' },
  { value: 'decker_street', label: 'Decker Street' },
  { value: 'didion_drive', label: 'Didion Drive' },
  { value: 'dorset_drive', label: 'Dorset Drive' },
  { value: 'dorset_place', label: 'Dorset Place' },
  { value: 'dry_dock_street', label: 'Dry Dock Street' },
  { value: 'dunstable_drive', label: 'Dunstable Drive' },
  { value: 'dunstable_lane', label: 'Dunstable Lane' },
  { value: 'dutch_london_street', label: 'Dutch London Street' },
  { value: 'eastbourne_way', label: 'Eastbourne Way' },
  { value: 'east_galileo_avenue', label: 'East Galileo Avenue' },
  { value: 'east_mirror_drive', label: 'East Mirror Drive' },
  { value: 'eclipse_boulevard', label: 'Eclipse Boulevard' },
  { value: 'edwood_way', label: 'Edwood Way' },
  { value: 'elgin_avenue', label: 'Elgin Avenue' },
  { value: 'el_burro_boulevard', label: 'El Burro Boulevard' },
  { value: 'el_rancho_boulevard', label: 'El Rancho Boulevard' },
  { value: 'equality_way', label: 'Equality Way' },
  { value: 'exceptionalists_way', label: 'Exceptionalists Way' },
  { value: 'fantastic_place', label: 'Fantastic Place' },
  { value: 'fenwell_place', label: 'Fenwell Place' },
  { value: 'forum_drive', label: 'Forum Drive' },
  { value: 'fudge_lane', label: 'Fudge Lane' },
  { value: 'galileo_road', label: 'Galileo Road' },
  { value: 'gentry_lane', label: 'Gentry Lane' },
  { value: 'ginger_street', label: 'Ginger Street' },
  { value: 'glory_way', label: 'Glory Way' },
  { value: 'goma_street', label: 'Goma Street' },
  { value: 'greenwich_parkway', label: 'Greenwich Parkway' },
  { value: 'greenwich_place', label: 'Greenwich Place' },
  { value: 'greenwich_way', label: 'Greenwich Way' },
  { value: 'grove_street', label: 'Grove Street' },
  { value: 'hanger_way', label: 'Hanger Way' },
  { value: 'hangman_avenue', label: 'Hangman Avenue' },
  { value: 'hardy_way', label: 'Hardy Way' },
  { value: 'hawick_avenue', label: 'Hawick Avenue' },
  { value: 'heritage_way', label: 'Heritage Way' },
  { value: 'hillcrest_avenue', label: 'Hillcrest Avenue' },
  { value: 'hillcrest_ridge_access_road', label: 'Hillcrest Ridge Access Road' },
  { value: 'imagination_court', label: 'Imagination Court' },
  { value: 'industry_passage', label: 'Industry Passage' },
  { value: 'ineseno_road', label: 'Ineseno Road' },
  { value: 'integrity_way', label: 'Integrity Way' },
  { value: 'invention_court', label: 'Invention Court' },
  { value: 'innocence_boulevard', label: 'Innocence Boulevard' },
  { value: 'jamestown_street', label: 'Jamestown Street' },
  { value: 'kimble_hill_drive', label: 'Kimble Hill Drive' },
  { value: 'kortz_drive', label: 'Kortz Drive' },
  { value: 'labor_place', label: 'Labor Place' },
  { value: 'laguna_place', label: 'Laguna Place' },
  { value: 'lake_vinewood_drive', label: 'Lake Vinewood Drive' },
  { value: 'las_lagunas_boulevard', label: 'Las Lagunas Boulevard' },
  { value: 'liberty_street', label: 'Liberty Street' },
  { value: 'lindsay_circus', label: 'Lindsay Circus' },
  { value: 'little_bighorn_avenue', label: 'Little Bighorn Avenue' },
  { value: 'low_power_street', label: 'Low Power Street' },
  { value: 'macdonald_street', label: 'Macdonald Street' },
  { value: 'mad_wayne_thunder_drive', label: 'Mad Wayne Thunder Drive' },
  { value: 'magellan_avenue', label: 'Magellan Avenue' },
  { value: 'marathon_avenue', label: 'Marathon Avenue' },
  { value: 'marlowe_drive', label: 'Marlowe Drive' },
  { value: 'melanoma_street', label: 'Melanoma Street' },
  { value: 'meteor_street', label: 'Meteor Street' },
  { value: 'milton_road', label: 'Milton Road' },
  { value: 'mirror_park_boulevard', label: 'Mirror Park Boulevard' },
  { value: 'mirror_place', label: 'Mirror Place' },
  { value: 'morningwood_boulevard', label: 'Morningwood Boulevard' },
  { value: 'mount_haan_drive', label: 'Mount Haan Drive' },
  { value: 'mount_haan_road', label: 'Mount Haan Road' },
  { value: 'mount_vinewood_drive', label: 'Mount Vinewood Drive' },
  { value: 'movie_star_way', label: 'Movie Star Way' },
  { value: 'mutiny_road', label: 'Mutiny Road' },
  { value: 'new_empire_way', label: 'New Empire Way' },
  { value: 'nikola_avenue', label: 'Nikola Avenue' },
  { value: 'nikola_place', label: 'Nikola Place' },
  { value: 'normandy_drive', label: 'Normandy Drive' },
  { value: 'north_archer_avenue', label: 'North Archer Avenue' },
  { value: 'north_conker_avenue', label: 'North Conker Avenue' },
  { value: 'north_sheldon_avenue', label: 'North Sheldon Avenue' },
  { value: 'north_rockford_drive', label: 'North Rockford Drive' },
  { value: 'occupation_avenue', label: 'Occupation Avenue' },
  { value: 'orchardville_avenue', label: 'Orchardville Avenue' },
  { value: 'palomino_avenue', label: 'Palomino Avenue' },
  { value: 'peaceful_street', label: 'Peaceful Street' },
  { value: 'perth_street', label: 'Perth Street' },
  { value: 'picture_perfect_drive', label: 'Picture Perfect Drive' },
  { value: 'plaice_place', label: 'Plaice Place' },
  { value: 'playa_vista', label: 'Playa Vista' },
  { value: 'popular_street', label: 'Popular Street' },
  { value: 'portola_drive', label: 'Portola Drive' },
  { value: 'power_street', label: 'Power Street' },
  { value: 'prosperity_street', label: 'Prosperity Street' },
  { value: 'prosperity_street_promenade', label: 'Prosperity Street Promenade' },
  { value: 'red_desert_avenue', label: 'Red Desert Avenue' },
  { value: 'richman_street', label: 'Richman Street' },
  { value: 'rockford_drive', label: 'Rockford Drive' },
  { value: 'roy_lowenstein_boulevard', label: 'Roy Lowenstein Boulevard' },
  { value: 'rub_street', label: 'Rub Street' },
  { value: 'sam_austin_drive', label: 'Sam Austin Drive' },
  { value: 'san_andreas_avenue', label: 'San Andreas Avenue' },
  { value: 'sandcastle_way', label: 'Sandcastle Way' },
  { value: 'san_vitus_boulevard', label: 'San Vitus Boulevard' },
  { value: 'senora_road', label: 'Senora Road' },
  { value: 'shank_street', label: 'Shank Street' },
  { value: 'signal_street', label: 'Signal Street' },
  { value: 'sinner_street', label: 'Sinner Street' },
  { value: 'sinners_passage', label: 'Sinners Passage' },
  { value: 'south_arsenal_street', label: 'South Arsenal Street' },
  { value: 'south_boulevard_del_perro', label: 'South Boulevard Del Perro' },
  { value: 'south_mo_milton_drive', label: 'South Mo Milton Drive' },
  { value: 'south_rockford_drive', label: 'South Rockford Drive' },
  { value: 'south_shambles_street', label: 'South Shambles Street' },
  { value: 'spanish_avenue', label: 'Spanish Avenue' },
  { value: 'steele_way', label: 'Steele Way' },
  { value: 'strangeways_drive', label: 'Strangeways Drive' },
  { value: 'strawberry_avenue', label: 'Strawberry Avenue' },
  { value: 'supply_street', label: 'Supply Street' },
  { value: 'sustancia_road', label: 'Sustancia Road' },
  { value: 'swiss_street', label: 'Swiss Street' },
  { value: 'tackle_street', label: 'Tackle Street' },
  { value: 'tangerine_street', label: 'Tangerine Street' },
  { value: 'tongva_drive', label: 'Tongva Drive' },
  { value: 'tower_way', label: 'Tower Way' },
  { value: 'tug_street', label: 'Tug Street' },
  { value: 'utopia_gardens', label: 'Utopia Gardens' },
  { value: 'vespucci_boulevard', label: 'Vespucci Boulevard' },
  { value: 'vinewood_boulevard', label: 'Vinewood Boulevard' },
  { value: 'vinewood_park_drive', label: 'Vinewood Park Drive' },
  { value: 'vitus_street', label: 'Vitus Street' },
  { value: 'voodoo_place', label: 'Voodoo Place' },
  { value: 'west_eclipse_boulevard', label: 'West Eclipse Boulevard' },
  { value: 'west_galileo_avenue', label: 'West Galileo Avenue' },
  { value: 'west_mirror_drive', label: 'West Mirror Drive' },
  { value: 'whispymound_drive', label: 'Whispymound Drive' },
  { value: 'wild_oats_drive', label: 'Wild Oats Drive' },
  { value: 'york_street', label: 'York Street' },
  { value: 'zancudo_barranca', label: 'Zancudo Barranca' },
  // Blaine County
  { value: 'algonquin_boulevard', label: 'Algonquin Boulevard' },
  { value: 'alhambra_drive', label: 'Alhambra Drive' },
  { value: 'armadillo_avenue', label: 'Armadillo Avenue' },
  { value: 'baytree_canyon_road', label: 'Baytree Canyon Road' },
  { value: 'calafia_road', label: 'Calafia Road' },
  { value: 'cascabel_avenue', label: 'Cascabel Avenue' },
  { value: 'cassidy_trail', label: 'Cassidy Trail' },
  { value: 'cat_claw_avenue', label: 'Cat-Claw Avenue' },
  { value: 'chianski_passage', label: 'Chianski Passage' },
  { value: 'cholla_road', label: 'Cholla Road' },
  { value: 'cholla_springs_avenue', label: 'Cholla Springs Avenue' },
  { value: 'duluoz_avenue', label: 'Duluoz Avenue' },
  { value: 'east_joshua_road', label: 'East Joshua Road' },
  { value: 'fort_zancudo_approach_road', label: 'Fort Zancudo Approach Road' },
  { value: 'galileo_road', label: 'Galileo Road' },
  { value: 'grapeseed_avenue', label: 'Grapeseed Avenue' },
  { value: 'grapeseed_main_street', label: 'Grapeseed Main Street' },
  { value: 'joad_lane', label: 'Joad Lane' },
  { value: 'joshua_road', label: 'Joshua Road' },
  { value: 'lesbos_lane', label: 'Lesbos Lane' },
  { value: 'lolita_avenue', label: 'Lolita Avenue' },
  { value: 'marina_drive', label: 'Marina Drive' },
  { value: 'meringue_lane', label: 'Meringue Lane' },
  { value: 'mount_haan_road', label: 'Mount Haan Road' },
  { value: 'mountain_view_drive', label: 'Mountain View Drive' },
  { value: 'niland_avenue', label: 'Niland Avenue' },
  { value: 'north_calafia_way', label: 'North Calafia Way' },
  { value: 'nowhere_road', label: 'Nowhere Road' },
  { value: 'oneil_way', label: "O'Neil Way" },
  { value: 'paleto_boulevard', label: 'Paleto Boulevard' },
  { value: 'panorama_drive', label: 'Panorama Drive' },
  { value: 'procopio_drive', label: 'Procopio Drive' },
  { value: 'procopio_promenade', label: 'Procopio Promenade' },
  { value: 'pyrite_avenue', label: 'Pyrite Avenue' },
  { value: 'raton_pass', label: 'Raton Pass' },
  { value: 'route_68_approach', label: 'Route 68 Approach' },
  { value: 'seaview_road', label: 'Seaview Road' },
  { value: 'senora_way', label: 'Senora Way' },
  { value: 'smoke_tree_road', label: 'Smoke Tree Road' },
  { value: 'union_road', label: 'Union Road' },
  { value: 'zancudo_avenue', label: 'Zancudo Avenue' },
  { value: 'zancudo_road', label: 'Zancudo Road' },
  { value: 'zancudo_trail', label: 'Zancudo Trail' },
];